import React from 'react';
import { FaBuilding, FaBriefcase, FaTrophy, FaUserCheck, FaMagic, FaFileAlt } from 'react-icons/fa';
import './loginPage.css'; // Import for the custom background

const LoginLeft = () => {
  return (
    // The parent div covers the left half and applies the custom background
    <div className="hidden lg:flex flex-col w-1/2 p-12 text-gray-333 login-left-bg text-left">

      {/* Logo */}
      <div className="text-3xl font-bold">
        <img src={require('../../../assets/MphLogo.png')} alt="MPH" className="w-24  mb-4" />
      </div>

      {/* Main Headline */}
      <div className="text-3xl mt-8 font-medium text-gray-333">
        <span>Find Your</span><br />
        <span className="text-gray-333 from-emerald-300 to-black bg-clip-text">Star Employee</span>
      </div>
      <p className="mt-4 text-sm text-gray-999">
        Connect with top talent and build exceptional teams with our AI-powered recruitment platform.
      </p>

      {/* Stats Section */}
      <div className="flex justify-between mt-8 text-left">
        <div className="flex items-center gap-4">
          {/* <FaBuilding className="text-2xl text-emerald-500" /> */}
          <div className="flex justify-center bg-flat p-3 rounded-lg">
            <img src={require('../../../assets/Companies.svg').default} alt="Companies" className='w-6' />
          </div>
          <div>
            <p className="text-2xl font-bold">500+</p>
            <p className="text-gray-999 text-sm">Companies</p>
          </div>
        </div>
        <div className="flex items-center gap-4">
          {/* <FaBriefcase className="text-3xl text-emerald-500" /> */}
          <div className="flex justify-center bg-flat p-3 rounded-lg">
            <img src={require('../../../assets/Jobs.svg').default} alt="jobs" className="w-6" />
          </div>
          <div>
            <p className="text-2xl font-bold">10K+</p>
            <p className="text-gray-999 text-sm">Jobs Posted</p>
          </div>
        </div>
        <div className="flex items-center gap-4">
          {/* <FaTrophy className="text-3xl text-emerald-500" /> */}
          <div className="flex justify-center bg-flat p-3 rounded-lg">
            <img src={require('../../../assets/SuccessRate.svg').default} alt="SuccessRate" className="w-6" />
          </div>
          <div>
            <p className="text-2xl font-bold">97%</p>
            <p className="text-gray-999 text-sm">Success Rate</p>
          </div>
        </div>
      </div>

      {/* Features Section */}
      <div className="mt-16 space-y-6">
        <div className="flex items-center gap-4 py-2">
          {/* <FaUserCheck className="text-2xl text-emerald-500"/> */}
          <div className="flex justify-center bg-flat p-3 rounded-lg">
            <img src={require('../../../assets/50k+Candidates.svg').default} alt="Candidates" className="w-6" />
          </div>
          <div>
            <h3 className="font-bold text-sm">50K+ Candidates</h3>
            <p className="text-gray-999 text-xs">Connect with pre-screened professionals</p>
          </div>
        </div>
        <div className="flex items-center gap-4 py-2">
          {/* <FaMagic className="text-2xl text-emerald-500"/> */}
          <div className="flex justify-center bg-flat p-3 rounded-lg">
            <img src={require('../../../assets/AI-Stars.svg').default} alt="AI-Stars" className="w-6" />
          </div>
          <div>
            <h3 className="font-bold text-sm">AI-Powered Matching</h3>
            <p className="text-gray-999 text-xs">Find the perfect fit using smart algorithms</p>
          </div>
        </div>
        <div className="flex items-center gap-4 py-2">
          {/* <FaFileAlt className="text-2xl text-emerald-500"/> */}
          <div className="flex justify-center bg-flat p-3 rounded-lg">
            <img src={require('../../../assets/Instant.svg').default} alt="Instant" className="w-6"/>
          </div>
          <div>
            <h3 className="font-bold text-sm">Instant Job Creation</h3>
            <p className="text-gray-999 text-xs">Create professional job posts in minutes</p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default LoginLeft;